export enum ICodes {
    OK = 200,
    NOT_FOUND = 404,
    VALIDATION_ERROR = 422,
    UNAUTHORIZED = 401,
}